import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { AddEntityItem, AddEntityText } from '../../typings/sidebar';
import { CampaignAndGroupSelectorEntityToSelectType } from '../../typings/state';

import './AddEntityMenu.css';
import * as keyset from './AddEntityMenu.i18n';

const i18n = i18nFactory(keyset);

export interface AddEntityMenuProps {
    openCampaignTypesMenu: () => void;
    openCampaignAndGroupSelector: (
        type: CampaignAndGroupSelectorEntityToSelectType
    ) => void;
    items: AddEntityItem[];
}

export class AddEntityMenu extends React.Component<AddEntityMenuProps> {
    render() {
        return (
            <div className={Bem.cls('add-entity-menu')}>
                <div className={Bem.cls('add-entity-menu', 'title')}>
                    {i18n('add')}
                </div>

                <div className={Bem.cls('add-entity-menu', 'menu')}>
                    {this.getItems()}
                </div>
            </div>
        );
    }

    private getItems() {
        const {
            openCampaignAndGroupSelector,
            openCampaignTypesMenu,
            items
        } = this.props;

        return items.map((el, index) => {
            const onClick = () => {
                el === CampaignAndGroupSelectorEntityToSelectType.CAMPAIGN
                    ? openCampaignTypesMenu()
                    : openCampaignAndGroupSelector(el);
            };

            const { title, description } = this.getTitleAndDescription(el);

            return (
                <div
                    className={Bem.cls('add-entity-menu', 'menu-item')}
                    key={index}
                    onClick={onClick}
                >
                    <div
                        className={Bem.cls(
                            'add-entity-menu',
                            'menu-item-title'
                        )}
                    >
                        {title}
                    </div>
                    <div
                        className={Bem.cls(
                            'add-entity-menu',
                            'menu-item-description'
                        )}
                    >
                        {description}
                    </div>
                </div>
            );
        });
    }

    private getTitleAndDescription(type: AddEntityItem): AddEntityText {
        switch (type) {
            case CampaignAndGroupSelectorEntityToSelectType.BANNER:
                return {
                    title: i18n('ad'),
                    description: i18n('ad-description')
                };
            case CampaignAndGroupSelectorEntityToSelectType.CAMPAIGN:
                return {
                    title: i18n('campaign'),
                    description: i18n('campaign-description')
                };
            case CampaignAndGroupSelectorEntityToSelectType.PHRASE:
                return {
                    title: i18n('phrase'),
                    description: i18n('phrase-description')
                };
            case CampaignAndGroupSelectorEntityToSelectType.GROUP:
                return {
                    title: i18n('group'),
                    description: i18n('group-description')
                };
            default:
                throw new Error('AddEntityValue is not supported!');
        }
    }
}
